// @flow

import React from "react";
import { observer } from "mobx-react";

import SidebarSelect from "../SidebarSelect";
import SidebarFilter from "../SidebarFilter";
import SidebarNDOSelect from "../SidebarNDOSelect";
import SidebarDateRangeSelect from "../SidebarDateRangeSelect";
import SidebarDaySelect from "../SidebarDaySelect";
import isSidebarFilterVisible from "../../helpers/isSidebarFilterVisible";

type Props = {
  computedDateFormat: string,
  computedDateMonthFormat: string,
  mappings: Object,
  pageContext: Object
};

function IHDepartureDateFilters(props: Props) {
  const { computedDateFormat, computedDateMonthFormat, mappings = {}, pageContext } = props;
  const { changeFilter, filters, sidebar } = pageContext;
  const { data: { quarter = [] } = {} } = mappings;

  const quarters = quarter.map(singleQuarter => {
    return {
      label: `${singleQuarter.substring(0, 4)} ${singleQuarter.substring(4)}`,
      value: singleQuarter
    };
  });

  return (
    <>
      <SidebarFilter isVisible={isSidebarFilterVisible("number of days to departure", "ndo", sidebar)}>
        <SidebarNDOSelect
          onChange={filterValue => changeFilter("ndo", filterValue)}
          title="Number of Days to Departure"
          values={filters.ndo}
        />
      </SidebarFilter>
      <SidebarFilter isVisible={isSidebarFilterVisible("departure quarter", "quarter", sidebar)}>
        <SidebarSelect
          fuzzySearch
          items={quarters}
          onChange={filterValue => changeFilter("quarter", filterValue)}
          selectedItems={filters.quarter}
          title="Quarter"
        />
      </SidebarFilter>
      <SidebarFilter isVisible={isSidebarFilterVisible("departure month", "depMonth", sidebar)}>
        <SidebarSelect
          computedDateFormat={computedDateFormat}
          computedDateMonthFormat={computedDateMonthFormat}
          fuzzySearch
          items={mappings.data.depMonth}
          onChange={filterValue => changeFilter("depMonth", filterValue)}
          selectedItems={filters.depMonth}
          title="Departure Month"
        />
      </SidebarFilter>
      <SidebarFilter isVisible={isSidebarFilterVisible("departure week", "depWeek", sidebar)}>
        <SidebarSelect
          computedDateFormat={computedDateFormat}
          computedDateMonthFormat={computedDateMonthFormat}
          fuzzySearch
          items={mappings.data.depWeek}
          onChange={filterValue => changeFilter("depWeek", filterValue)}
          selectedItems={filters.depWeek}
          title="Departure Week"
        />
      </SidebarFilter>
      <SidebarFilter isVisible={isSidebarFilterVisible("departure date", "depDate", sidebar)}>
        <SidebarDateRangeSelect
          computedDateFormat={computedDateFormat}
          computedDateMonthFormat={computedDateMonthFormat}
          dates={filters.depDate}
          onChange={filterValue => changeFilter("depDate", filterValue)}
          title="Departure Date"
        />
      </SidebarFilter>
      <SidebarFilter isVisible={isSidebarFilterVisible("departure day of week", "depDow", sidebar)}>
        <SidebarDaySelect
          onChange={filterValue => changeFilter("depDow", filterValue)}
          selectedItems={filters.depDow}
          title="Departure Day of Week"
        />
      </SidebarFilter>
    </>
  );
}

export default observer(IHDepartureDateFilters);
